<div class="display-flex"><h1>{{projectTitle}}</h1> 
    <span class="flex-grow-1"></span>
    <mat-icon mat-dialog-close>close</mat-icon>
 </div>
<div>
    <form #basicForm="ngForm">
        <div class="form-row flex-items-centered">
            <div class="flex-grow-1">
                <div class="merlin-control">
                    <div class="label-cont">
                        <label class="mer-label">Program</label>
                    </div>
                    <div class="control-cont">
                        <mat-select class="mer-select" name="program" [(ngModel)]="model.program"
                            (selectionChange)="loadActivities()" required>
                            <mat-option *ngFor="let program of programs" [value]="program">{{program.name}}
                            </mat-option>
                        </mat-select>

                    </div>
                </div>

            </div>

            <div class="flex-grow-1">
                <div class="merlin-control">
                    <div class="label-cont">
                        <label class="mer-label">Activity</label>
                    </div>
                    <div class="control-cont">
                        <mat-select class="mer-select" name="activity" [(ngModel)]="model.activity" required>
                            <mat-option *ngFor="let activity of activities" [value]="activity">
                                {{activity.name}}</mat-option>
                        </mat-select>

                    </div>
                </div>

            </div>

            <div class="flex-grow-1">
                <div class="merlin-control">
                    <div class="label-cont">
                        <label class="mer-label">Verb</label>
                    </div>
                    <div class="control-cont">
                        <mat-select class="mer-select" name="verb" [(ngModel)]="model.verb" required>
                            <mat-option *ngFor="let verb of verbs" [value]="verb">
                                {{verb.en}}</mat-option>
                        </mat-select>

                    </div>
                </div>

            </div>

            <div class="flex-grow-1" *ngIf="!contactsOnly">
                <div class="merlin-control">
                    <div class="label-cont">
                        <label class="mer-label">Actor</label>
                    </div>
                    <div class="control-cont">
                        <input type="text" class="mer-text-field" name="name" [(ngModel)]="model.actor" required />

                    </div>
                </div>

            </div>
            <div class="flex-grow-1" *ngIf="contactsOnly">
                <div class="merlin-control">
                    <div class="label-cont">
                        <label class="mer-label">Actor</label>
                    </div>
                    <div class="control-cont">
                        <mat-select class="mer-select" name="actor" [(ngModel)]="model.actor" required>
                            <mat-option *ngFor="let contact of contacts" [value]="contact">
                                {{contact.firstName}} {{contact.lastName}}</mat-option>
                        </mat-select>

                    </div>
                </div>

            </div>

            <div class="flex-grow-1">
                <div class="merlin-control">
                    <div class="label-cont">
                        <label class="mer-label">Result</label>
                    </div>
                    <div class="control-cont">
                        <input type="text" class="mer-text-field" name="result" [(ngModel)]="model.result" />

                    </div>
                </div>

            </div>
        </div>
        <div class="btn-position">
            <button type="button" class="main-btn general-btn margin-r-l" (click)="reset(basicForm,true)">Reset All</button>
            <button type="button" class="main-btn general-btn" (click)="reset(basicForm)">Reset</button>
            <div class="flex-grow-1"></div>
            <button type="button" class="main-btn filled-general-btn" (click)="submit(basicForm)">Submit</button>

        </div>

    </form>
</div>